import { render } from "./StudioDataLeft.vue?vue&type=template&id=cb36adce"
import script from "./StudioDataLeft.vue?vue&type=script&lang=js"
export * from "./StudioDataLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__